module.exports = __webpack_public_path__ + "img/bestPrice.45ef06a5.gif";